// extracted by mini-css-extract-plugin
export var centerText = "_e4-8";
export var container = "_e4-0";
export var doughnutContainer = "_e4-7";
export var legend = "_e4-a";
export var legendItemColorDisplay = "_e4-b";
export var legendItemLabel = "_e4-d";
export var legendItemValue = "_e4-c";
export var lg = "_e4-5";
export var maxWidth = "_e4-9";
export var md = "_e4-4";
export var responsive = "_e4-6";
export var sm = "_e4-3";
export var xs = "_e4-2";
export var xxs = "_e4-1";